export const DOTS_PER_INCH = 300;
export const HEAD_DOTS = 720;
export const mmToDots = (mm) => Math.round((mm * DOTS_PER_INCH) / 25.4);
export const ptToDots = (pt) => Math.round((pt * DOTS_PER_INCH) / 72);
export const MEDIA = {
    // DK-11204 multi-purpose 17 x 54 mm, die-cut
    dk11204_17x54: {
        media: 'dk11204_17x54',
        widthMm: 17,
        lengthMm: 54,
        continuous: false,
        printableDots: { width: 165, length: 566 },
        offsetDots: { left: 555, right: 0 },
        brother: { mediaType: 0x0b, widthMm: 17, lengthMm: 54 },
    },
    // DK-11209 small address 29 x 62 mm label on 62 mm tape (62 across the head, 29 along), die-cut
    dk11209_29x62: {
        media: 'dk11209_29x62',
        widthMm: 62,
        lengthMm: 29,
        continuous: false,
        printableDots: { width: 696, length: 271 },
        offsetDots: { left: 12, right: 12 },
        brother: { mediaType: 0x0b, widthMm: 62, lengthMm: 29 },
    },
    // DK-11202 shipping 62 x 100 mm, die-cut
    dk11202_62x100: {
        media: 'dk11202_62x100',
        widthMm: 62,
        lengthMm: 100,
        continuous: false,
        printableDots: { width: 696, length: 1109 },
        offsetDots: { left: 12, right: 12 },
        brother: { mediaType: 0x0b, widthMm: 62, lengthMm: 100 },
    },
    // DK-22205 continuous 62 mm, cut at 90 mm (length 0 in the print-information command)
    dk22205_62x90: {
        media: 'dk22205_62x90',
        widthMm: 62,
        lengthMm: 90,
        continuous: true,
        printableDots: { width: 696, length: mmToDots(90) },
        offsetDots: { left: 12, right: 12 },
        brother: { mediaType: 0x0a, widthMm: 62, lengthMm: 0 },
    },
};
//# sourceMappingURL=media.js.map